import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16fa5cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "La liste des sociétés", -1))
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_4 = { class: "flex card-toolbar w-full" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "p-input-icon-left w-10/12" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "card-toolbar w-full" }
const _hoisted_9 = { class: "flex flex-col justify-center" }
const _hoisted_10 = { class: "card-body pt-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Actions", -1))

import { ref, onMounted, onBeforeMount } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { fetchCompanies } from "@/_services/company/company";
import { ICompany } from "@/models/company/ICompany";
import router from "@/router";

const localStorageKey = "selectedCompanies";
const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyList',
  setup(__props) {

const isLoading = ref<boolean>(true);
const companies = ref<Array<ICompany>>([]);
const tableData = ref<Array<ICompany>>(companies);
const totalSelectedCompanies = ref<number>(0);
const selectedCompanies = ref(Array<ICompany>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];

onBeforeMount(() => {
    localStorage.removeItem(localStorageKey);
});

onMounted(async () => {
    totalSelectedCompanies.value = selectedCompanies.value.length;
    await populateDataTableWithLocalStorageFilters();
});

function onSearchInputDt() {
    let search = criteria.value.trim();
    showSpinner();
    populateDatatable(
        rows.value,
        page.value,
        "" != search ? search : "",
    );
}

const showSpinner = () => {
    isLoading.value = true;
}

async function populateDatatable(
    itemsPerPage,
    page,
    criteria?
) {
    showSpinner();
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchCompanies(
        itemsPerPage,
        page,
        criteria,
        criteria !== "" ? criteria : undefined,
    );
    totalRecords.value = totalRecordsDt.value;
    isLoading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
}

async function populateDataTableWithLocalStorageFilters(
    itemsPerPage?: number,
    page?: number
) {
    let localStorageRowPerPage = getLocalStorageRowsPerPage();
    let localStorageFisrtPageState = getLocalStorageFisrtPageState();
    
    let currentPage = page;
    if (!currentPage) {
        currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
    }

    let currentItemsPerPage = itemsPerPage;
    if (!currentItemsPerPage) {
        currentItemsPerPage = localStorageRowPerPage;
    }

    populateDatatable(
        currentItemsPerPage,
        currentPage,
        criteria.value,
    );
}

async function onPaginate(e) {
    showSpinner();
    rows.value = e.rows;
    page.value = e.page + 1;
    setLocalStorageRowsPerPage(rows.value);
    populateDataTableWithLocalStorageFilters(rows.value, page.value);
}

function getLocalStorageData() {
    let storageData = localStorage.getItem(localStorageKey);
    
    if (null !== storageData && "undefined" !== storageData) {
        return JSON.parse(storageData);
    }

    return null;
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
    let storageData = localStorage.getItem(localStorageKey);
    if (null !== storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(localStorageKey, JSON.stringify(localStorageObject));
    }
}

function getLocalStorageRowsPerPage() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }

    return defaultRowsPerPage;
}

function getLocalStorageFisrtPageState() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.first) {
        return localStorageData.first;
    }

    return 0;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        dataKey: "uuid",
        stateStorage: "local",
        ref: "dt",
        "state-key": localStorageKey,
        value: tableData.value,
        paginator: true,
        rows: rows.value,
        rowHover: true,
        removableSort: "",
        selection: selectedCompanies.value,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((selectedCompanies).value = $event)),
        metaKeySelection: false,
        loading: isLoading.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: rowsPerPageOptions,
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        onPage: _cache[3] || (_cache[3] = ($event: any) => (onPaginate($event)))
      }, {
        loading: _withCtx(() => [
          _createTextVNode(" Chargement... ")
        ]),
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "w-9/12",
                    modelValue: criteria.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                    placeholder: "Recherche par société",
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (onSearchInputDt()))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, "Nombre total de sociétés : " + _toDisplayString(totalRecords.value), 1)
              ])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(Column), {
              field: "name",
              header: "Société"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_11
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-eye",
                  class: _normalizeClass(["p-button-eye", `${slotProps.data.uuid}`]),
                  style: {"margin-right":"0.5em"},
                  title: "Voir",
                  onClick: ($event: any) => (_unref(router).push({ name: 'hiddenMasterProductByCompanyList', params: { uuid: slotProps.data.uuid } }))
                }, null, 8, ["class", "onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "selection", "loading", "totalRecords", "currentPage"])
    ])
  ], 64))
}
}

})